import PropTypes from 'prop-types';

const ConnectionSuccessIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.8216867,19.4826958 C37.3012048,19.4826958 36.8385542,19.5409836 36.3180723,19.5992714 C35.1036145,13.0127505 29.3783133,8 22.4963855,8 C14.6891566,8 8.38554217,14.3533698 8.38554217,22.1639344 C8.38554217,23.154827 8.50120482,24.0874317 8.6746988,24.9617486 C8.26987952,24.9034608 7.92289157,24.845173 7.51807229,24.845173 C3.35421687,24.845173 0,28.2258652 0,32.4225865 C0,36.6193078 3.35421687,40 7.51807229,40 C11.1036145,40 34.5253012,40 37.8216867,40 C43.4313253,40 48,35.3952641 48,29.7413479 C48,24.0874317 43.4313253,19.4826958 37.8216867,19.4826958 Z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

ConnectionSuccessIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ConnectionSuccessIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ConnectionSuccessIcon;
